import {get} from '../utils'
import {includeQuery} from './utils';

export default host => (clientId, include = "include=category;country;image;blogLocations;contentCreatorTypesBlacklist;licensePlan;color;permissions;managedBy.image;socialLinks;translations;domain;defaultChannel.domain") =>
  get(`${host}/clients/${clientId}?${include}`)
    .then(response => response.json())
    .then(json => json.data)
